import {NgModule} from '@angular/core';

import {HighlightPanelComponent} from './highlight-panel.component';

@NgModule({
  declarations: [HighlightPanelComponent],
  exports: [HighlightPanelComponent],
})
export class HighlightPanelModule {}
